import ListMyinfoChild from "@components/_Revamp/ListMyinfoChild";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import {
  updateChildItem,
  updateSelectedChild,
  updatePartialDataStep4,
} from "@redux/slices/CCP/step4Slice";
import React, { useEffect, useLayoutEffect, useMemo, useState } from "react";
import { Text } from "../Text";
import { css } from "@linaria/core";
import { TitleAndDescription } from "@components/_Revamp/TitleAndDescription";
import { useHistory } from "react-router-dom";
import { ROUTE_PATH } from "@static/route-paths";
import arrow from "@assets/icon/chevron-down-primary.svg";
import { updateToIntialState1 } from "@redux/slices/CCP/step1Slice";
import { updateToIntialState2 } from "@redux/slices/CCP/step2Slice";
import { updateToDefaultStateStep3 } from "@redux/slices/SHIELD_STARTER/step3Slice";
import { updateToIntialState3 } from "@redux/slices/CCP/step3Slice";
import { SCREEN_SIZE } from "@static/screen-size";
import { CustomButton, Header, ModalButtonContainer, ModalDescription, modalPadding } from "@pages/CCP/steps/Declaration/UserDeclaration";
import { themeDefault } from "src/theme-revamp";
import Modal from "@components/_Revamp/Modal";


interface IProp {}

function ChildInfo() {
  const childData = useAvivaSelector((state) => state.cancerCoverStep4);
  const selectedChild = useAvivaSelector(state=>state.cancerCoverStep4.selectedChildInfo)
  const [showChildNotFoundModal, setShowChildNotFoundModal] = useState(false)
  const dispatch = useAvivaDispatch();
  const history = useHistory();
  const onChange = (payload: {
    itemType: string;
    index: number;
    item: any;
  }) => {
    dispatch(
      updateChildItem({
        itemType: payload.itemType,
        index: payload.index,
        item: payload.item,
      })
    );
    if(payload.item?.nric === selectedChild?.nric){
      dispatch(updateSelectedChild( payload.item))
    }
  };

  const onRestart = ()=>{
    dispatch(updateToIntialState1({}))
    dispatch(updatePartialDataStep4({
      singpassInitiatedOrManual: null,
      selectedChildInfo: null,
      errorState: {},
      availToPurch: null,
      purchThroMyself: null,
      existingCCPPlan: null,
      doesNotQualifProd: null,
      policyAppInProcess: null,
      myInfo: {
        salutation: "",
        firstName: "",
        lastName: "",
        fullName: "",
        mobileNum: "",
        emailId: "",
        nric: "",
        dateOfBirth: "",
        nationality: "",
        residentialStatus: "",
        gender: "",
        mailingAddress: null,
        stayInTouch: null,
        colorFlag: null,
        address: {
          country: "SG",
          block: "",
          unitNo: "",
          street: "",
          postal: "",
          building: "",
        },
        nationalityCode: "",
        customerId: null,
        age: -1,
      },
      myinfoTransactionId: "",
      isMyInfoSumbitted: false,
      isMailingAddressConfirmed: false,
      rentalPostalCustomer: "",
      dobMisMatch: false
    }));
    history.replace(ROUTE_PATH.CANCER_COVER_LANDING_PAGE)
    return;
  }

  const onSelect = (payload: any) => {
    dispatch(updateSelectedChild(payload));
  };

  const childDataArr = useMemo(()=>{
    const processedData = [
      {
        title: "Eligible to buy",
        sideButton: "SELECT",
        flagColor: "#00AC95",
        itemType: "availToPurch",
        onChange,
        onSelect,
        toolTip:null,
        childrenData: [],
      },
      {
        title: "Buy via 'Myself'",
        sideButton: "RESTART",
        flagColor: "#00AC95",
        itemType: "purchThroMyself",
        onChange,
        onSelect,
        onRestart,
        toolTip: {
          title: `Buy via 'Myself'`,
          content: `Your child who is aged 16 and above must select the "Myself" option to buy.`,
        },
        childrenData: null,
      },
      {
        title: "Not eligible to buy",
        sideButton: null,
        flagColor: "#C50000",
        itemType: "doesNotQualifProd",
        onChange,
        onSelect,
        onRestart,
        toolTip: {
          title: "Not eligible to buy",
          content: "As this product may not be suitable for your child, please contact your Financial Adviser Representative for further assistance.",
        },
        childrenData: null,
      },
      {
        title: "Existing Singlife Cancer Cover Plus policy", // check with ben for the existing CCP plan title
        sideButton: null,
        flagColor: "#C50000",
        itemType: "existingCCPPlan",
        onChange,
        onSelect,
        toolTip: {
          title: "Existing Singlife Cancer Cover Plus policy",
          content: "You already have a Cancer Cover Policy with Singlife",
        },
        childrenData: null,
      },
      {
        title: "Application being processed",
        sideButton: null,
        flagColor: "#C50000",
        itemType: "policyAppInProcess",
        onChange,
        onSelect,
        toolTip: {
          title: "Application being processed",
          content: "You may have bought a Cancer Cover policy recently and the application is still being processed.",
        },
        childrenData: null,
      },
    ].reduce((acc: any, current) => {
      const data = childData[current.itemType as keyof typeof childData];
      if (data && data.length > 0) {
        current.childrenData = data || [];
        acc.push(current);
      }
      return acc;
    }, []);

    return processedData
  },[childData])

  return (
    <>
      <div className={titleStyle}>
        <p>Your Child's Details</p>
        <p>
          You can only purchase for 1 child at a time. To purchase for another
          child, please start a new application.
        </p>
      </div>
      <ListMyinfoChild key={"1"} data={childDataArr} />
      <div className={titleStyle}>
        <span>
          <a
            href={""}
            onClick={(e) => {
              e.preventDefault()
              setShowChildNotFoundModal(true);
            }}
          >
            Can't see your child's details?
            <img src={arrow} alt="arrow icon" />
          </a>
        </span>
      </div>
      <hr />
      <Modal
        onClose={() => {
          setShowChildNotFoundModal(false);
        }}
        show={showChildNotFoundModal}
        colseBtnColor={themeDefault.colors.primary}
        className={modalPadding}
      >
        <>
          <Header marginTop={"0"}>We've encountered an issue</Header>
          <ModalDescription>
          If you do not see your child, you can contact our Financial Adviser Representative for help. 
          </ModalDescription>
          <ModalButtonContainer>
            <CustomButton
              filled={false}
              onClick={() => {
                setShowChildNotFoundModal(false);
                history.push(ROUTE_PATH.CANCER_COVER_LANDING_PAGE);
              }}
            >
              Back to home
            </CustomButton>
            <CustomButton
              filled={true}
              onClick={() => {
                history.push(ROUTE_PATH.CANCER_COVER_CONTACT_US);
              }}
            >
              Contact us
            </CustomButton>
          </ModalButtonContainer>
        </>
      </Modal>
    </>
  );
}

export default ChildInfo;

const titleStyle = css`
  font-weight: 600;
  margin-bottom: 48px;
  display: flex;
  flex-direction: column;
  & > p:first-child {
    font-size: 18px;
    color: #434343;
    line-height: 25.2px;
    margin-bottom: 16px;
  }
  p:nth-child(2) {
    font-size: 14px;
    color: #8a8988;
    line-height: 19.6px;
    text-align: justify;

  }

  span {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    a {
      text-decoration: none;
      color: #883e89;
    }

    img {
      transform: rotate(-90deg);
      margin-left: 5px;
    }
  }

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    & > p:first-child {
    font-size: 28px;
    line-height: 39.2px;
    margin-bottom: unset;

  }
  p:nth-child(2) {
    font-size: 14px;
    line-height: 19.6px;
    text-align: unset;
  }
  }
`;
